import React, { useEffect } from 'react';
import BrandImageDetailCard from 'components/brand-image-detail-card';
import BrandDetailsCard from 'components/brand-details-card';
import { ALL_BRAND_TYPE_OPTIONS } from 'utils/constants';
import ShopStatus from 'components/shop-status';
import useNewShopContext from 'contexts/create-shop.context';
import PolygonCard from 'components/shop-polygon-card';
import { PolygonItemType } from 'components/polygon-card/polygon-item';

const CreateShopPreview = () => {
  const { createShopForm, setCreateShopForm, setDisabled, polygons, setActivePolygon } =
    useNewShopContext();
  const brandImageData = {
    brandImage: createShopForm?.images?.[0],
    brandLogo: createShopForm?.logo
  };

  const POLYGON_MENU: PolygonItemType[] = [];

  useEffect(() => {
    if (
      createShopForm?.name &&
      createShopForm?.short_text &&
      createShopForm?.description &&
      createShopForm?.images?.[0] &&
      createShopForm?.logo
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [createShopForm]);

  return (
    <div>
      <div className='w-full max-w-[746px]'>
        <BrandDetailsCard
          data={{ label: 'Brand Name', value: createShopForm?.name }}
          className='my-6'
        />
        <BrandDetailsCard
          data={{ label: 'Brand Tagline', value: createShopForm?.short_text }}
          className='my-6'
        />

        <BrandDetailsCard
          data={{ label: 'Brand Description', value: createShopForm?.description }}
          className='my-6'
        />

        <BrandDetailsCard
          data={{ label: 'Phone Number', value: createShopForm?.phone }}
          className='my-6'
        />

        <BrandDetailsCard
          data={{ label: 'Email Address', value: createShopForm?.email }}
          className='my-6'
        />

        <BrandDetailsCard
          data={{
            label: 'Address',
            value: createShopForm?.address.address_line
          }}
          className='my-6'
        />

        {createShopForm.brand_type ? (
          <BrandDetailsCard
            data={{
              label: 'Brand Type',
              value: ALL_BRAND_TYPE_OPTIONS.find((o) => o.value === createShopForm.brand_type)?.text
            }}
            className='my-6'
          />
        ) : null}

        <ShopStatus
          comment={createShopForm?.brandStatustext}
          setComment={(k: string) => setCreateShopForm({ ...createShopForm, brandStatustext: k })}
          className='my-6'
          selectedShopStatus={createShopForm.shopStatus}
          setSelectedShopStatus={(d) => setCreateShopForm({ ...createShopForm, shopStatus: d })}
          disabled
        />

        <BrandImageDetailCard data={brandImageData} />

        <div className='flex-1'>
          <PolygonCard
            list={POLYGON_MENU}
            polygons={polygons}
            setActivePolygon={setActivePolygon}
          />
        </div>

        <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
          <div className='w-[150px]'>
            <p className='text-[#858585] text-sm font-medium'>Keywords</p>
          </div>

          <div className='flex gap-[12px] flex-wrap'>
            {createShopForm?.brand_keywords?.map((item, index) => (
              <div
                key={index}
                className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
                <p className='text-[#E60A2B] text-sm'>{item.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
          <div className='w-[150px]'>
            <p className='text-[#858585] text-sm font-medium'>Descriptive Metadata</p>
          </div>

          <div className='flex gap-[12px] flex-wrap'>
            {createShopForm?.brand_descriptive_metadatas?.map((item, index) => (
              <div
                key={index}
                className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
                <p className='text-[#E60A2B] text-sm'>{item.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='w-full flex gap-[30px] border border-[#EAEBEB] px-[24px] py-[20px] rounded-xl my-6  justify-start'>
          <div className='w-[150px]'>
            <p className='text-[#858585] text-sm font-medium'>Business Metadata</p>
          </div>

          <div className='flex gap-[12px] flex-wrap'>
            {createShopForm?.brand_business_metadatas?.map((item, index) => (
              <div
                key={index}
                className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
                <p className='text-[#E60A2B] text-sm'>{item.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex gap-[12px] flex-wrap mt-4'>
          {createShopForm?.platform_fee ? (
            <div className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>Platform Fee: {createShopForm.platform_fee}</p>
            </div>
          ) : null}

          {createShopForm?.platform_fee_cap ? (
            <div className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>
                Platform Fee Cap: ₦{createShopForm.platform_fee_cap}
              </p>
            </div>
          ) : null}

          {createShopForm?.service_fee ? (
            <div className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>Service Fee: {createShopForm.service_fee}</p>
            </div>
          ) : null}

          {createShopForm?.service_fee_cap ? (
            <div className='bg-[#FEF0F2] flex gap-[5px] items-center rounded-[20px] px-[12px] pt-[2px] pb-[3px]'>
              <p className='text-[#E60A2B] text-sm'>
                Service Fee Cap: ₦{createShopForm.service_fee_cap}
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CreateShopPreview;
